
export const environment = {
   production: true,
   apiRoot: 'https://api-wls-stackup.attekmi.co/api',
   appRoot: 'https://api-wls-stackup.attekmi.co',
   isEnableErrorHandler: 'true',
   apiForLogger: 'https://api-wls-stackup.attekmi.co/api/log/error',
   echoKey: 'stackup',
   echoHost: 'api-wls-stackup.attekmi.co',
   echoPort: '443',
   echoHttps: 'true',

};